import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import HomeLayout from "./layout/HomeLayout";
import HomePage from "./pages/homePages/HomePage";
import Signup from "./pages/authPages/Signup";
import Login from "./pages/authPages/Login";
import TrackingPage from "./pages/homePages/TrackingPage";
import ShippingPage from "./pages/homePages/ShippingPage";
import SupportPage from "./pages/homePages/SupportPage";
import DashBoard from "./pages/dashboardPages/DashBoard";
import DashboardLayout from "./layout/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUser } from "./app/features/userSlice";
import ManageShipping from "./pages/dashboardPages/ManageShipping";
import OrderPage from "./pages/homePages/OrderPage";
import ShippingDetails from "./pages/dashboardPages/ShippingDetails";
import EditShipping from "./pages/dashboardPages/EditShipping";
import ManageUsers from "./pages/dashboardPages/ManageUsers";
import UserDetails from "./pages/dashboardPages/UserDetails";
import ProfilePage from "./pages/dashboardPages/ProfilePage";
import AboutUs from "./pages/homePages/AboutUs";

function App() {
  const dispatch = useDispatch();
  const userStatus = useSelector((state) => state.user.status);
  const user = useSelector((state) => state.user.profile);
  const token = !!localStorage.getItem("access_token");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (userStatus === "idle" && token) {
      dispatch(fetchUser());
    }
  }, [userStatus, dispatch, token]);

  useEffect(() => {
    if (!user) {
      if (!user && userStatus === "failed" && token) {
        localStorage.removeItem("access_token");
      }
      const route = location.pathname.includes("/admin/dashboard");
      if (route && !token) {
        navigate("/");
      }
    }
    // eslint-disable-next-line
  }, [location.pathname, user, token, userStatus]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <HomeLayout>
            <HomePage />
          </HomeLayout>
        }
      />
      <Route
        path="/secured/signup"
        element={
          <HomeLayout>
            <Signup />
          </HomeLayout>
        }
      />
      <Route
        path="/secured/login"
        element={
          <HomeLayout>
            <Login />
          </HomeLayout>
        }
      />
      <Route
        path="/track"
        element={
          <HomeLayout>
            <TrackingPage />
          </HomeLayout>
        }
      />
      <Route
        path="/track/:tracking_id"
        element={
          <HomeLayout>
            <OrderPage />
          </HomeLayout>
        }
      />
      <Route
        path="/ship"
        element={
          <HomeLayout>
            <ShippingPage />
          </HomeLayout>
        }
      />
      <Route
        path="/support"
        element={
          <HomeLayout>
            <SupportPage />
          </HomeLayout>
        }
      />
      <Route
        path="/about-us"
        element={
          <HomeLayout>
            <AboutUs />
          </HomeLayout>
        }
      />

      {/* Admin Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <DashboardLayout>
            <DashBoard />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/manage-shipping"
        element={
          <DashboardLayout>
            <ManageShipping />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/manage-users"
        element={
          <DashboardLayout>
            <ManageUsers />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/manage-shipping/:tracking_id"
        element={
          <DashboardLayout>
            <ShippingDetails />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/manage-shipping/:tracking_id/edit"
        element={
          <DashboardLayout>
            <EditShipping />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/manage-users/:id"
        element={
          <DashboardLayout>
            <UserDetails />
          </DashboardLayout>
        }
      />
      <Route
        path="/admin/dashboard/profile"
        element={
          <DashboardLayout>
            <ProfilePage />
          </DashboardLayout>
        }
      />
    </Routes>
  );
}

export default App;
